import { FaFacebook, FaInstagram, FaEnvelope, FaGithub } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-black text-white snap-start py-6 text-center">
      <div className="mb-4 flex justify-center space-x-6">
        {/* Facebook */}
        <a
          href="https://www.facebook.com/rammir.timbas.2024"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green hover:text-opacity-80 transition"
        >
          <FaFacebook size={24} />
        </a>
        {/* Instagram */}
        <a
          href="https://www.instagram.com/rain2goaway15?igsh=YmR6NGRhZzNrNHIw"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green hover:text-opacity-80 transition"
        >
          <FaInstagram size={24} />
        </a>
        {/* Gmail */}
        <a
          href="mailto:rammirtimbas321@gmail.com"
          className="text-green hover:text-opacity-80 transition"
        >
          <FaEnvelope size={24} />
        </a>
        {/* GitHub */}
        <a
          href="https://github.com/RammirTimbas"
          target="_blank"
          rel="noopener noreferrer"
          className="text-green hover:text-opacity-80 transition"
        >
          <FaGithub size={24} />
        </a>
      </div>
      <p className="font-pixelBody">
        &copy; {new Date().getFullYear()} Rammir. All Rights Reserved.
      </p>
      <p className="font-pixelAccent text-gray-400">
        Built with React & Tailwind CSS.
      </p>
    </footer>
  );
}

export default Footer;
